import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import { getClearbitUrl } from 'pricing-pages-lib/utils/urls';
import styled from 'styled-components';
import { useAppSelector } from '../../reducers';
import { isUngatedForCBXClearbit } from '../../selectors/GatingSelectors';
import { getClickedLinkEvent } from '../../utils/event-tracking/interactions';
import { trackEvent } from '../../utils/event-tracking/track-event';
const StyledAlert = styled(UIAlert).withConfig({
  displayName: "ClearbitBanner__StyledAlert",
  componentId: "sc-1rrgyfb-0"
})(["div h5{margin-right:16px !important;}"]);

const ClearbitBanner = () => {
  const isUngatedForClearbit = useAppSelector(isUngatedForCBXClearbit);
  if (!isUngatedForClearbit) return null;

  const onClick = () => {
    trackEvent(getClickedLinkEvent({
      type: 'external',
      url: getClearbitUrl(),
      location: 'clearbit banner'
    }));
  };

  return /*#__PURE__*/_jsx(StyledAlert, {
    type: "info",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.banners.clearbit.headline"
    }),
    children: /*#__PURE__*/_jsxs(UIFlex, {
      gap: 10,
      align: "center",
      wrap: "wrap",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.banners.clearbit.description"
      }), /*#__PURE__*/_jsx(UIButton, {
        href: getClearbitUrl(),
        use: "tertiary",
        size: "sm",
        className: "p-x-3",
        onClick: onClick,
        external: true,
        target: "_blank",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.banners.clearbit.cta"
        })
      })]
    })
  });
};

export default ClearbitBanner;